<template>
  <ui-modal v-bind="$attrs" v-on="$listeners">
    <template #activator="scope">
      <slot name="activator" v-bind="scope" />
    </template>

    <template #title>
      Unclaimed taxes
    </template>

    <div
      v-for="item in taxes"
      :key="item.id"
      class="d-flex justify-content-between align-items-center mt-4"
    >
      <router-link
        :to="{ name: 'location-view', params: { locationId: item.id }}"
        class="card-label overview-card__label"
      >
        {{ item.name }}
      </router-link>
      <div class="card-value">
        {{ item.amount | money(item.currency)}}
      </div>
    </div>
  </ui-modal>
</template>

<script>
export default {

  props: {
    taxes: {
      type: Array,
      required: true,
    },
  },
};
</script>
